<template>
  <div class="rounded border border-gray-200 bg-white">
    <img v-if="image" class="h-48 w-60 object-cover rounded-t" :src="image" alt="Image" />

    <header
      v-if="$slots.Label || $slots.Actions"
      class="p-6 border-b border-b-gray-200 flex justify-between items-center"
    >
      <h1 class="heading-display flex-grow">
        <slot name="Label" />
      </h1>

      <div class="flex items-center">
        <slot name="Actions" />
      </div>
    </header>

    <div :class="[contentClass, { 'bg-gray-50': $slots.Footer }]">
      <slot />
    </div>

    <footer v-if="$slots.Footer" class="p-6 border-t border-gray-200">
      <slot name="Footer" />
    </footer>
  </div>
</template>

<script src="./card.component.ts" lang="ts" />
